import SiteEnum from '@models/enums/SiteEnum';
import { IArticleHeader } from '@models/IHero';
import ArticleHeader from '@organisms/ArticleHeader/ArticleHeader';

const ArticleHeaderWrapper = (props: IArticleHeader) => (
  <ArticleHeader {...props} site={SiteEnum.B2B} />
);

export default ArticleHeaderWrapper;
